import { Button } from "antd";
import styled from "styled-components";
import { darkenHex } from "../../../utils/helpers";

export const ReportsFooterWrapper = styled.footer`
  position: fixed;
  width: 98%;
  background-color: white;
  height: 80px;
  left: 50%;
  transform: translate(-50%, -50%);
  bottom: -40px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  overflow-x: auto;
  margin: 0 auto;
  padding: 0 15px;
  scrollbar-width: thin;
  
  &::-webkit-scrollbar {
    height: 6px;
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: #d9d9d9;
    border-radius: 3px;
  }

  @media (max-width: 1440px) {
    justify-content: flex-start;
  }
`;

export const StyledButton = styled(Button)`
  border-radius: 6px;
  padding: 7px 10px;
  border-width: 1px;
  border-style: solid;
  background: none;
  outline: none;
  box-shadow: none;
  font-size: 13px;
  white-space: nowrap;
  color: #000000;
  transition: all 0.3s ease;
  flex-shrink: 0;

  &:hover {
    color: #000000 !important;
    transform: translateY(-2px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  &:hover span {
    color: #000000 !important;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SkeletonSwitch = styled.div`
  width: 50px;
  height: 30px;
  background: #f0f0f0;
  border-radius: 15px;
  margin-right: 10px;
`;

export const FooterButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;

  button {
    min-width: 100px;
  }
`;

export const ResizableContainer = styled.div`
  position: relative;
  resize: vertical;
  overflow: hidden;
  min-height: 200px;
  max-height: 800px;
  /* margin-bottom: 40px; */
  /* border: 1px solid #d9d9d9; */
  /* border-radius: 4px; */
  display: flex;
  flex-direction: column;

  .quill {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;

    .ql-toolbar {
      flex: 0 0 auto;
    }

    .ql-container {
      flex: 1;
      overflow: auto;
      height: auto;

      .ql-editor {
        min-height: 150px;
        height: 100%;
      }
    }
  }

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    right: 0;
    width: 10px;
    height: 10px;
    cursor: se-resize;
    background: #f0f0f0;
  }
`;

export const MailsButtons = styled.div`
  border-radius: 10px;
  background: #f0f0f0;
  display: flex;
  gap: 8px;
  padding: 8px;
  align-items: center;
  margin-right: 10px;
`;


export const EmailButton = styled(Button) <{ color: string }>`
   background: ${props => props.color};
   border-color: ${props => props.color};
   border-radius: 6px;
   padding: 7px 10px;
   color: #000000;
   white-space: nowrap;
   flex: 1;
   transition: all 0.3s ease;
   font-size: 12px;
   font-weight: 500;

   &:hover {
    background: ${props => darkenHex(props.color, 20)} !important;
    border-color: ${props => darkenHex(props.color, 20)} !important;
  }
`;

